/* Magix globe: a liquid-chrome Earth turning on its axis, with network cables
   arcing between cities and a satellite on an orbit ring. WebGL draws the globe
   (#globe3d); a 2D canvas on top draws the cables and orbit (#globeNet). */
(function () {
  var glCanvas = document.getElementById('globe3d');
  var net = document.getElementById('globeNet');
  if (!glCanvas || !net) return;
  var gl = glCanvas.getContext('webgl', { premultipliedAlpha: true, antialias: false, alpha: true });
  var ctx = net.getContext('2d');
  if (!gl || !ctx) return;

  var FOC = 1.8, CAMZ = 5.4, TILT = 0.41; /* Earth's 23.4 degree tilt */

  /* ---- Land mask: simplified continents in lon/lat, painted to a texture ---- */
  var LAND = [
    [[-168,65],[-140,70],[-110,72],[-85,70],[-65,62],[-55,50],[-67,45],[-75,38],[-81,31],[-80,25],[-90,29],[-97,26],[-97,20],[-87,21],[-83,15],[-78,8],[-85,11],[-92,15],[-105,20],[-112,30],[-118,34],[-124,40],[-124,48],[-133,56],[-150,60],[-165,60]],
    [[-55,60],[-42,60],[-20,70],[-20,80],[-40,83],[-65,80],[-58,70]],
    [[-80,10],[-60,11],[-50,0],[-35,-6],[-39,-15],[-48,-26],[-58,-38],[-65,-42],[-68,-52],[-74,-52],[-73,-40],[-71,-18],[-81,-5]],
    [[-10,36],[-9,43],[-2,44],[-5,48],[2,51],[8,54],[12,57],[5,62],[15,69],[28,71],[40,67],[40,55],[30,45],[28,41],[22,38],[18,40],[12,44],[8,44],[3,42],[-2,36]],
    [[-6,50],[2,51],[0,53],[-2,57],[-5,58],[-6,55],[-4,53]],
    [[-17,15],[-17,21],[-10,30],[-6,36],[10,37],[20,32],[32,31],[35,28],[43,12],[51,12],[42,-2],[40,-10],[40,-16],[35,-24],[33,-30],[20,-35],[17,-30],[12,-17],[13,-6],[9,4],[-8,4],[-14,10]],
    [[44,-25],[50,-16],[49,-12],[44,-17]],
    [[28,41],[36,36],[35,30],[43,13],[52,16],[58,22],[56,26],[62,25],[67,24],[72,20],[77,8],[80,14],[80,16],[87,21],[92,22],[98,16],[98,8],[103,1],[104,10],[109,12],[108,21],[117,24],[122,30],[121,40],[126,38],[129,35],[130,43],[140,48],[143,59],[155,60],[163,62],[180,66],[180,71],[140,73],[110,77],[80,73],[60,70],[40,67],[40,55],[30,45]],
    [[130,31],[136,34],[141,36],[142,41],[145,44],[141,45],[139,40],[133,35]],
    [[95,5],[105,-6],[120,-9],[140,-8],[150,-6],[135,-2],[118,5],[108,1]],
    [[114,-22],[122,-18],[130,-12],[137,-12],[142,-11],[146,-19],[153,-25],[150,-37],[141,-38],[135,-35],[129,-32],[115,-34]],
    [[166,-46],[172,-41],[175,-37],[178,-38],[174,-42],[169,-47]],
    [[-180,-70],[180,-70],[180,-90],[-180,-90]]
  ];
  var MW = 1024, MH = 512;
  var paint = document.createElement('canvas'); paint.width = MW; paint.height = MH;
  var pc = paint.getContext('2d');
  pc.fillStyle = '#000'; pc.fillRect(0, 0, MW, MH);
  pc.fillStyle = '#fff';
  LAND.forEach(function (poly) {
    pc.beginPath();
    poly.forEach(function (p, i) {
      var x = (p[0] + 180) / 360 * MW, y = (90 - p[1]) / 180 * MH;
      if (i) pc.lineTo(x, y); else pc.moveTo(x, y);
    });
    pc.closePath(); pc.fill();
  });
  var mask = paint;
  try {
    var soft = document.createElement('canvas'); soft.width = MW; soft.height = MH;
    var sc = soft.getContext('2d');
    sc.filter = 'blur(3px)';
    sc.drawImage(paint, 0, 0);
    if (sc.filter === 'blur(3px)') mask = soft;
  } catch (e) {}

  var VS = 'attribute vec2 a; void main(){ gl_Position = vec4(a, 0.0, 1.0); }';
  var FS = [
    'precision highp float;',
    'uniform vec2 uRes; uniform float uTime, uSpin, uTilt, uCamZ; uniform sampler2D uLand;',
    'const float FOC = 1.8;',
    'vec3 rotY(vec3 v, float a){ float c = cos(a), s = sin(a); return vec3(c*v.x + s*v.z, v.y, -s*v.x + c*v.z); }',
    'vec3 rotZ(vec3 v, float a){ float c = cos(a), s = sin(a); return vec3(c*v.x - s*v.y, s*v.x + c*v.y, v.z); }',
    'float land(vec3 q){',
    '  float lon = atan(q.x, q.z), lat = asin(clamp(q.y, -1.0, 1.0));',
    '  return smoothstep(0.25, 0.75, texture2D(uLand, vec2(lon / 6.2831853 + 0.5, 0.5 - lat / 3.1415927)).r);',
    '}',
    /* Same studio environment as the hero chrome, in Magix blues */
    'vec3 env(vec3 d){',
    '  float y = d.y;',
    '  vec3 c = mix(vec3(0.0, 0.01, 0.32), vec3(0.5, 0.53, 1.0), smoothstep(-0.6, 0.8, y));',
    '  c += vec3(1.0) * smoothstep(0.07, 0.0, abs(y - 0.12)) * 0.95;',
    '  c += vec3(1.0) * smoothstep(0.72, 0.95, y) * 1.3;',
    '  c += vec3(0.9, 0.92, 1.0) * smoothstep(0.8, 0.97, abs(d.x)) * smoothstep(0.65, 0.0, abs(y)) * 1.1;',
    '  c += vec3(0.75, 0.78, 1.0) * smoothstep(0.9, 0.99, d.z) * 0.6;',
    '  c *= mix(0.22, 1.0, smoothstep(-0.9, -0.05, y));',
    '  return c;',
    '}',
    'void main(){',
    '  vec2 uv = (gl_FragCoord.xy - 0.5 * uRes) / uRes.y;',
    '  vec3 ro = vec3(0.0, 0.0, uCamZ);',
    '  vec3 rd = normalize(vec3(uv, -FOC));',
    '  float b = dot(ro, rd), h = b * b - (dot(ro, ro) - 1.0);',
    '  if (h <= 0.0) { gl_FragColor = vec4(0.0); return; }',
    '  float px = uCamZ / (FOC * uRes.y);',
    '  float alpha = clamp((1.0 - sqrt(max(1.0 - h, 0.0))) / (1.5 * px), 0.0, 1.0);',
    '  vec3 p = ro + rd * (-b - sqrt(h));',
    '  vec3 q = rotY(rotZ(p, -uTilt), -uSpin);',
    '  float m = land(q);',
    '  vec3 tu = normalize(cross(vec3(0.0, 1.0, 0.001), q));',
    '  vec3 tv = cross(q, tu);',
    '  float e = 0.012;',
    '  vec3 g = (tu * (land(normalize(q + tu * e)) - m) + tv * (land(normalize(q + tv * e)) - m)) / e;',
    /* Liquid ripples flowing over the surface, calmer on land */
    '  vec3 w = q * 4.0; float t = uTime * 0.6;',
    '  vec3 rip = vec3(sin(w.y * 1.7 + t + sin(w.z * 1.3 - t)),',
    '                  sin(w.z * 1.9 - t * 1.1 + sin(w.x * 1.1 + t)),',
    '                  sin(w.x * 1.5 + t * 0.9 + sin(w.y * 1.6 - t * 0.7)));',
    '  vec3 nObj = normalize(q - g * 0.04 + rip * mix(0.06, 0.022, m));',
    '  vec3 n = rotZ(rotY(nObj, uSpin), uTilt);',
    '  vec3 r = reflect(rd, n);',
    '  float fre = pow(1.0 - max(dot(n, -rd), 0.0), 3.0);',
    '  vec3 tint = mix(vec3(0.5, 0.56, 1.0), vec3(1.1, 1.1, 1.14), m);',
    '  vec3 col = env(r) * tint * mix(vec3(0.85, 0.88, 1.0), vec3(1.05), fre);',
    '  col += pow(max(dot(r, normalize(vec3(0.4, 0.8, 0.5))), 0.0), 48.0) * 1.3;',
    '  col = col / (1.0 + col * 0.3);',
    '  gl_FragColor = vec4(col * alpha, alpha);',
    '}'
  ].join('\n');

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(s)); return null; }
    return s;
  }
  var vs = compile(gl.VERTEX_SHADER, VS), fs = compile(gl.FRAGMENT_SHADER, FS);
  if (!vs || !fs) return;
  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'a');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mask);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

  var U = {};
  ['uRes', 'uTime', 'uSpin', 'uTilt', 'uCamZ', 'uLand'].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });
  gl.uniform1i(U.uLand, 0);

  /* ---- Cities and the cables between them ---- */
  var CITY = {
    lon: [-0.1, 51.5], nyc: [-74, 40.7], la: [-118.2, 34], mex: [-99.1, 19.4], sao: [-46.6, -23.5],
    lag: [3.4, 6.5], cpt: [18.4, -33.9], nbo: [36.8, -1.3], dxb: [55.3, 25.2], bom: [72.8, 19],
    sin: [103.8, 1.3], tyo: [139.7, 35.7], sel: [127, 37.5], syd: [151.2, -33.9], par: [2.35, 48.9]
  };
  var LINKS = [
    ['lon', 'nyc'], ['nyc', 'la'], ['lon', 'dxb'], ['dxb', 'bom'], ['bom', 'sin'], ['sin', 'tyo'],
    ['tyo', 'la'], ['sin', 'syd'], ['lag', 'lon'], ['sao', 'nyc'], ['cpt', 'nbo'], ['nbo', 'dxb'],
    ['mex', 'sao'], ['par', 'lag'], ['sel', 'tyo'], ['syd', 'la'], ['lag', 'sao'], ['cpt', 'sao'],
    ['par', 'nbo'], ['sel', 'sin'], ['mex', 'la'], ['lon', 'par']
  ];
  function vec(ll, r) {
    var la = ll[1] * Math.PI / 180, lo = ll[0] * Math.PI / 180;
    return [Math.cos(la) * Math.sin(lo) * r, Math.sin(la) * r, Math.cos(la) * Math.cos(lo) * r];
  }
  var cables = LINKS.map(function (l, i) {
    var a = vec(CITY[l[0]], 1), b = vec(CITY[l[1]], 1);
    var ang = Math.acos(Math.max(-1, Math.min(1, a[0] * b[0] + a[1] * b[1] + a[2] * b[2])));
    var pts = [], N = 48;
    for (var k = 0; k <= N; k++) {
      var s = k / N, sa = Math.sin(ang);
      var w1 = Math.sin((1 - s) * ang) / sa, w2 = Math.sin(s * ang) / sa;
      var lift = 1.004 + (0.06 + 0.22 * ang / Math.PI) * Math.sin(Math.PI * s);
      pts.push([(a[0] * w1 + b[0] * w2) * lift, (a[1] * w1 + b[1] * w2) * lift, (a[2] * w1 + b[2] * w2) * lift]);
    }
    return { a: l[0], b: l[1], pts: pts, offset: (i * 0.37) % 1, period: 7 + (i % 5) * 0.8 };
  });
  var nodes = Object.keys(CITY).map(function (k) { return { id: k, p: vec(CITY[k], 1.006) }; });

  function rotY(v, a) { var c = Math.cos(a), s = Math.sin(a); return [c * v[0] + s * v[2], v[1], -s * v[0] + c * v[2]]; }
  function rotZ(v, a) { var c = Math.cos(a), s = Math.sin(a); return [c * v[0] - s * v[1], s * v[0] + c * v[1], v[2]]; }
  function rotX(v, a) { var c = Math.cos(a), s = Math.sin(a); return [v[0], c * v[1] - s * v[2], s * v[1] + c * v[2]]; }

  var W = 1, H = 1, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function project(P) {
    var k = FOC / (CAMZ - P[2]);
    return [W / 2 + P[0] * k * H, H / 2 - P[1] * k * H];
  }
  function visible(P) {
    var dx = P[0], dy = P[1], dz = P[2] - CAMZ;
    var L = Math.sqrt(dx * dx + dy * dy + dz * dz);
    dx /= L; dy /= L; dz /= L;
    var b = dz * CAMZ, c = CAMZ * CAMZ - 1, disc = b * b - c;
    if (disc <= 0) return true;
    var t1 = -b - Math.sqrt(disc);
    return !(t1 > 0 && t1 < L - 0.002);
  }

  function drawNet(t, spin) {
    ctx.clearRect(0, 0, W, H);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    var toWorld = function (v) { return rotZ(rotY(v, spin), TILT); };

    /* Orbit ring with a satellite, behind-the-globe parts hidden */
    var ringTilt = 1.18, ringYaw = 0.5, R = 1.36, seg = 128, sat = (t * 0.22) % 1;
    ctx.lineWidth = 1 * dpr;
    for (var i = 0; i < seg; i++) {
      var a0 = i / seg * Math.PI * 2, a1 = (i + 1) / seg * Math.PI * 2;
      var p0 = rotY(rotX([Math.cos(a0) * R, 0, Math.sin(a0) * R], ringTilt), ringYaw);
      var p1 = rotY(rotX([Math.cos(a1) * R, 0, Math.sin(a1) * R], ringTilt), ringYaw);
      if (!visible(p0) || !visible(p1)) continue;
      var s0 = project(p0), s1 = project(p1);
      ctx.strokeStyle = 'rgba(220,226,255,' + (0.18 + 0.32 * Math.max(0, p0[2])) + ')';
      ctx.beginPath(); ctx.moveTo(s0[0], s0[1]); ctx.lineTo(s1[0], s1[1]); ctx.stroke();
    }
    var sa = sat * Math.PI * 2;
    var sp = rotY(rotX([Math.cos(sa) * R, 0, Math.sin(sa) * R], ringTilt), ringYaw);
    if (visible(sp)) {
      var ss = project(sp), sr = (4 + 2 * Math.max(0, sp[2])) * dpr;
      var sg = ctx.createRadialGradient(ss[0] - sr * 0.35, ss[1] - sr * 0.35, 0, ss[0], ss[1], sr);
      sg.addColorStop(0, '#ffffff'); sg.addColorStop(0.5, '#c9cfff'); sg.addColorStop(1, 'rgba(70,80,255,0)');
      ctx.fillStyle = sg; ctx.beginPath(); ctx.arc(ss[0], ss[1], sr, 0, Math.PI * 2); ctx.fill();
    }

    /* Cables grow out from one city, carry a pulse, then retract into the other */
    var live = {};
    cables.forEach(function (c) {
      var ph = ((t / c.period) + c.offset) % 1;
      if (ph > 0.82) return;
      var from = 0, to = 1;
      if (ph < 0.28) to = ph / 0.28;
      else if (ph > 0.62) from = (ph - 0.62) / 0.2;
      to = to * to * (3 - 2 * to); from = from * from * (3 - 2 * from);
      live[c.a] = live[c.b] = true;
      var N = c.pts.length - 1, i0 = Math.floor(from * N), i1 = Math.ceil(to * N);
      var pass = [[5.5, 'rgba(120,135,255,0.28)'], [1.6, 'rgba(255,255,255,0.92)']];
      pass.forEach(function (ps) {
        ctx.lineWidth = ps[0] * dpr; ctx.strokeStyle = ps[1];
        ctx.beginPath();
        var pen = false;
        for (var k = i0; k <= i1; k++) {
          var P = toWorld(c.pts[k]);
          if (!visible(P)) { pen = false; continue; }
          var s = project(P);
          if (pen) ctx.lineTo(s[0], s[1]); else { ctx.moveTo(s[0], s[1]); pen = true; }
        }
        ctx.stroke();
      });
      if (ph > 0.28 && ph < 0.62) {
        var q = (ph - 0.28) / 0.34, kk = Math.round(q * N);
        var P = toWorld(c.pts[kk]);
        if (visible(P)) {
          var s = project(P), r = 3.2 * dpr;
          var g = ctx.createRadialGradient(s[0], s[1], 0, s[0], s[1], r * 2.4);
          g.addColorStop(0, 'rgba(255,255,255,1)'); g.addColorStop(1, 'rgba(160,170,255,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(s[0], s[1], r * 2.4, 0, Math.PI * 2); ctx.fill();
        }
      }
    });

    /* City nodes */
    nodes.forEach(function (n) {
      var P = toWorld(n.p);
      if (!visible(P)) return;
      var s = project(P), r = (live[n.id] ? 3.2 : 2) * dpr;
      ctx.fillStyle = live[n.id] ? 'rgba(255,255,255,0.95)' : 'rgba(225,230,255,0.6)';
      ctx.beginPath(); ctx.arc(s[0], s[1], r, 0, Math.PI * 2); ctx.fill();
      if (live[n.id]) {
        ctx.strokeStyle = 'rgba(255,255,255,0.35)'; ctx.lineWidth = 1 * dpr;
        ctx.beginPath(); ctx.arc(s[0], s[1], r * 2.4, 0, Math.PI * 2); ctx.stroke();
      }
    });
  }

  function size() {
    var w = glCanvas.clientWidth, h = glCanvas.clientHeight;
    if (!w || !h) return;
    W = net.width = glCanvas.width = Math.round(w * dpr);
    H = net.height = glCanvas.height = Math.round(h * dpr);
    gl.viewport(0, 0, W, H);
    draw(time);
  }

  var time = 6.0;
  function draw(t) {
    var spin = t * 0.16 + 1.2;
    gl.uniform2f(U.uRes, W, H);
    gl.uniform1f(U.uTime, t);
    gl.uniform1f(U.uSpin, spin);
    gl.uniform1f(U.uTilt, TILT);
    gl.uniform1f(U.uCamZ, CAMZ);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    drawNet(t, spin);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var onScreen = true, running = false, t0 = performance.now();
  function frame(now) {
    if (!onScreen || document.hidden || reduce.matches) { running = false; return; }
    time = 6.0 + (now - t0) / 1000;
    draw(time);
    requestAnimationFrame(frame);
  }
  function start() {
    if (reduce.matches) { draw(time); return; }
    if (running) return;
    running = true; requestAnimationFrame(frame);
  }
  if (window.ResizeObserver) new ResizeObserver(size).observe(glCanvas);
  else window.addEventListener('resize', size);
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) start(); }).observe(glCanvas);
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
  if (reduce.addEventListener) reduce.addEventListener('change', start);
  size();
  start();
})();
